import React, { useState, useRef, useEffect } from "react";

import axios from "axios";


import logo from "../Assets/Kabakoo.png";
import collapseIcon from "../Assets/arrow-down.svg";
import loader from "../Assets/loading.svg";
import FLAG_ML from "../Assets/flags/ML.png";

import { countrylist } from "../config/countrylist";
import { main_end_point, ticket_anonyme_end_point } from "../config/baseUrl";
import copyright from "../config/copyright.json";

import "./style.css";
import Loader from "./Loader";
import {
  getLocalStorageData,
  handleDataStructure,
  urlConfiguration,
  validatePhoneNumber,
} from "../config/helpers";
import Header from "./Header";
import HeaderTicket from "./HeaderTicket";

// Mode développement - Mettre à true pour désactiver Turnstile
const isDevMode = false;

function SignIn({ componentDidMount }) {
  const [displayDropdownItems, setDisplayDropdownItems] = useState(false);
  const [countryInformation, setCountryInformation] = useState({
    countryName: "Mali",
    indicatif: "+223",
    flag: FLAG_ML,
  });
  const [indicatif, setIndicatif] = useState("+223");
  const [phone, setPhone] = useState("");
  const [phoneIsOk, setPhoneIsOk] = useState(false);
  const [load, setLoad] = useState(false);
  const [alert, setAlert] = useState(0);
  const [form, setForm] = useState(1);
  const [error, setError] = useState({ is: false, message: "" });

  const [help, setHelp] = useState(false);

  let storeData = getLocalStorageData();
  useEffect(() => {
    setHelp(storeData.kaba_info.help);
  }, [help]);

  useEffect(() => {
    // Charger le script Turnstile seulement si pas en mode dev
    if (!isDevMode) {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // Initialiser le widget Turnstile
        if (window.turnstile && turnstileRef.current) {
          window.turnstile.render(turnstileRef.current, {
            sitekey: '0x4AAAAAAB9F9oM13w2uITiD',
            callback: function(token) {
              setTurnstileToken(token);
            },
            'expired-callback': function() {
              setTurnstileToken('');
            },
            'error-callback': function() {
              setTurnstileToken('');
            }
          });
        }
      };
      document.head.appendChild(script);

      return () => {
        // Nettoyer le script lors du démontage
        document.head.removeChild(script);
      };
    }
  }, []);

  const turnstileRef = useRef(null);
  const [turnstileToken, setTurnstileToken] = useState("");

  // the functions
  const dropdownItems = (e) => {
    setDisplayDropdownItems(!displayDropdownItems);
  };

  const handlePhoneIsOk = (e) => {
    let phone = e.target.value;
    setPhoneIsOk(validatePhoneNumber(phone));
    validatePhoneNumber(phone)
      ? setError({ is: false, message: "" })
      : setError({ is: true, message: copyright.phone["101"] });
    setPhone(phone);
  };

  const selectCountry = (countryName, indicatif, flag) => {
    setCountryInformation({
      countryName: countryName,
      indicatif: indicatif,
      flag: flag,
    });
    setDisplayDropdownItems(!displayDropdownItems);
    setIndicatif(indicatif);
  };

  // a implementer, le popup
  const alertIfAllAreOk = (e) => {
    e.preventDefault();
    setAlert(1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(0);
    setLoad(true);

    // Si en mode dev, bypass Turnstile
    if (isDevMode) {
      help
        ? handleSubmitTicket()
        : hash_phone(countryInformation.indicatif.concat(phone));
    } else {
      // Mode production avec vérification Turnstile
      const token = turnstileToken;
      if (window.turnstile) {
        window.turnstile.reset();
      }
      setTurnstileToken("");

      const data = { token: token };

      await axios
      .post(`${main_end_point}/check_re_captcha/`, data)
      .then((response) => {
          help
            ? handleSubmitTicket()
            : hash_phone(countryInformation.indicatif.concat(phone));
        })
        .catch((error) => {
          let status = error.response.status;
          let code = error.response.data.code;
          if (status == 400) {
            setError({ is: true, message: copyright.recaptcha[`${code}`] });
          }
          setLoad(false);
        });
    }
  };

  // cette function de hasher le phone number
  const hash_phone = async (phone) => {
    const data = { phone: phone };
    await axios
      .post(`${main_end_point}/hash_phone/`, data)
      .then((response) => {
        let phone_hash = response.data.hashed_phone;

        let storeData = getLocalStorageData();
        let old_hashed_phone = storeData.kaba_info.neguediourou;
        let old_phone = storeData.kaba_info.phone
        let kaba_token = storeData.kaba_info["kabakoo.africa.token"];
        if (old_phone !== phone || old_hashed_phone === "" || kaba_token === "") {
          send_otp(phone_hash, phone);
        } else {
          check_token(old_hashed_phone, phone_hash, kaba_token, phone);
        }
        
        // if (storeData.kaba_info.phone !== phone) {
        //   send_otp(phone_hash, phone);
        // }
        // // on verifie si les donnees old_hashed_phone et le token exixte
        // else if (old_hashed_phone !== "" && kaba_token !== "") {
        //   check_token(old_hashed_phone, phone_hash, kaba_token, phone);
        // } else {
        //   // on envoie l'otp
        //   send_otp(phone_hash, phone);
        // }
      })
      .catch((error) => {
        setLoad(false);
        // console.log(error.response);
        let status = error.response.status;
        let code = error.response.data.code;
        if (status == 400) {
          setError({ is: true, message: copyright.hash_phone[`${code}`] });
        }
      });
  };
  const send_otp = async (hash_phone, phone) => {
    const data = {
      hashed_phone: hash_phone,
    };
    await axios
      .post(`${main_end_point}/send_otp/`, data)
      .then((response) => {
        let code = response.data.code;
        let type;
        switch (code) {
          case 100:
            type = "signin";
            break;
          case 101:
            type = "signup";
            break;
          default:
            type = "signin";
            break;
        }
        handleDataStructure("one_time_password_id", response.data.otp_id);
        handleDataStructure(
          "one_time_password_quota_day",
          response.data.remaining_daily_otps
        );
        handleDataStructure("neguediourou", hash_phone);
        handleDataStructure("phone", phone);
        handleDataStructure("one_time_passoword_type", type);
        handleDataStructure("time", response.data.new_delay);
        handleDataStructure("verification", "");
        // c'est pour actualliser l'appication dans le but d'afficher bon  composant
        componentDidMount(1);
      })
      .catch((error) => {
        let code = error.response.data.code;
        setError({ is: true, message: copyright.send_otp[`${code}`] });
        setLoad(false);
      });
  };

  const check_token = async (old_hashed_phone, new_hashed_phone, token, phone) => {
    const data = {
      old_hashed_phone: old_hashed_phone,
      new_hashed_phone: new_hashed_phone,
      token: token,
    };
    await axios
      .post(`${main_end_point}/check_token/`, data)
      .then((response) => {
        let phone_hash = response.data.hashed_phone;

        let storeData = getLocalStorageData();
        // on redirige l'apprenant
        window.location.href = urlConfiguration(
          new_hashed_phone,
          token,
          storeData.kaba_info.source
        );
      })
      .catch((error) => {
        send_otp(new_hashed_phone, phone);
        setLoad(false);
      });
  };

  const handleSubmitTicket = () => {
    const file = storeData.kaba_info.ticket.data[0].value;
    const text = storeData.kaba_info.ticket.data[1].value;

    // Validation des champs ou autres logiques de traitement avant l'envoi
    // console.log(file);
    // Envoi des données au serveur
    const formData = new FormData();
    if (file || text.length > 0) {
      if (file.blob !== "") {
        const buildFileSinceABlobFile = new File([file.blob], file.name, {
          type: file.type,
        });
        console.log(buildFileSinceABlobFile);

        formData.append("medias", buildFileSinceABlobFile, file.name);
      }

      if (text.length > 0) {
        formData.append("content", text);
      }
      formData.append("phone", indicatif + "" + phone);

      // Remplacez 'URL_DU_ENDPOINT' par l'URL réelle de votre endpoint backend
      axios
        .post(ticket_anonyme_end_point, formData)
        .then((response) => {
          // Réinitialisation des champs après le traitement
          const object = {};
          handleDataStructure("ticket.data", object);
          handleDataStructure("oups", "");

          const currentDate = new Date();

          // Il faut ajouter 30 s a la date
          const newDate = new Date(currentDate.getTime() + 30 * 1000);

          handleDataStructure("time", newDate);
          componentDidMount(10);
        })
        .catch((error) => {
          // Gérez les erreurs de l'envoi des données
          console.warn("Erreur lors de l'envoi des données :", error);
        });

      // const object = {};
      // handleDataStructure('ticket.data', object)
      // handleDataStructure('oups', '')
      // componentDidMount(10)
    } else {
      // Gestion des erreurs si les champs ne sont pas valides ou vides
      console.warn("Veuillez sélectionner un fichier et saisir du texte.");
    }
  };

  return (
    <div>
      <div className="heading">
        <div className="logo">
          <div className="image">
            <img src={logo} alt="logo" />
          </div>
        </div>
        {help ? <HeaderTicket /> : <Header />}
      </div>
      <div
        className="popup-parent"
        style={{ display: alert === 1 ? "block" : "none" }}
      >
        <div className="popup">
          <div className="phone-number">
            {countryInformation.indicatif.concat(phone)}
          </div>
          <div className="text">{copyright.phone["102"]}</div>
          <div className="btn-group">
            <button type="button" className="one" onClick={() => setAlert(0)}>
              Modifier
            </button>
            <button type="button" className="two" onClick={handleSubmit}>
              Oui
            </button>
          </div>
        </div>
      </div>

      <div className="form">
        <form
          method="post"
          onSubmit={alertIfAllAreOk}
          style={{ opacity: form }}
        >
          <div
            className="input-block"
            style={{ position: "relative" }}
            onClick={dropdownItems}
          >
            <div style={{ display: "flex" }} onClick={dropdownItems}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={countryInformation.flag}
                  alt={"flag " + countryInformation.name}
                  style={{ marginRight: "10px" }}
                />
              </div>
              <div id="indicatif">{countryInformation.countryName}</div>
            </div>
            <div
              className="collapseIcon"
              onClick={dropdownItems}
              style={{ display: alert === 0 ? "flex" : "none" }}
            >
              <img src={collapseIcon} alt="icon" />
            </div>
            <div
              className={`list ${displayDropdownItems ? "visible" : "hidden"}`}
              style={{ display: displayDropdownItems }}
            >
              <ul>
                {countrylist.map((country, index) => (
                  <li
                    key={index}
                    onClick={() =>
                      selectCountry(
                        country.name,
                        `+${country.dialCode}`,
                        country.flag
                      )
                    }
                  >
                    <img
                      src={country.flag}
                      alt={"flag " + country.name}
                      style={{ marginRight: "10px" }}
                    />
                    {country.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="input-block" style={{ display: "flex" }}>
            <span>{countryInformation.indicatif}</span>
            <input
              type="number"
              name=""
              id="phone"
              placeholder="Numéro de téléphone"
              onChange={(e) => handlePhoneIsOk(e)}
              required
            />
          </div>
          {/* <Recaptcha
            sitekey="6Lch3l4iAAAAAOjNFWoCqIxUbDpZb6p61YMkjKH5"
            ref={captchaRef}
          /> */}
          {!isDevMode && (
            <div
              id="turnstile-widget"
              ref={turnstileRef}
              data-theme="light"
            ></div>
          )}
          <div className="conditions" style={{marginTop: '23px'}}>
            <p>En continuant, tu acceptes nos <a href="https://www.kabakoo.africa/privacy-policy" target="_blank" rel="noopener noreferrer"> <br />Conditions d'utilisation </a> <br /> et notre <a href="https://www.kabakoo.africa/privacy-policy" target="_blank" rel="noopener noreferrer">Politique de confidentialité</a>.</p>
          </div>

          <div
            className="button input-block"
            style={{ display: alert === 0 ? "block" : "none" }}
          >
            {load ? (
              <Loader img={loader} />
            ) : phone && phoneIsOk && (isDevMode || turnstileToken) ? (
              <input type="submit" value="Continuer" />
            ) : (
              <input type="button" value="Envoyer" style={{ opacity: 0.3 }} />
            )}
          </div>
          <div className="error">{error.is && <p>{error.message}</p>}</div>
        </form>
      </div>
    </div>
  );
}

export default SignIn;
